import Button from "kustom-front/src/components/atoms/Button";
import React, { FunctionComponent, useState } from "react";
import { FormattedMessage } from "react-intl";
import CartAutoCompleteStreetInput from "@Components/molecules/cart/CartAddressForm/CartAutoCompleteStreetInput";
import useCartContext from "@Hooks/useCartContext";
import useNotificationsContext from "@Hooks/useNotificationsContext";
import { AutoCompletePlace, MondialRelayLocationContent } from "@Types/addresses";
import { ApiErrorResponse } from "@Types/api/error";
import { convertFromApiToMondialRelayLocationContent } from "@Utils/cart/addresses";
import "./style.scss";

interface Props {
  onSubmit: (place: AutoCompletePlace | undefined) => void;
}

interface ContainerProps {
  onSubmit: (locations: MondialRelayLocationContent[]) => void;
}

export const CartMondialRelayForm: FunctionComponent<Props> = ({ onSubmit }) => {
  const [searchedAddress, setSearchedAddress] = useState<string>("");
  const [submittedAddress, setSubmittedAddress] = useState<AutoCompletePlace>();

  const handleSelectStreet = (place: AutoCompletePlace) => {
    const autoCompleteStreet =
      place.route === ""
        ? `${place.locality || ""}`
        : place.street_number === ""
        ? `${place.route || ""} ${place.locality || ""}`
        : `${place.street_number || ""} ${place.route || ""} ${place.locality || ""}`;
    setSearchedAddress(autoCompleteStreet);
    setSubmittedAddress(place);
  };

  return (
    <div className="CartMondialRelayForm">
      <div className="CartMondialRelayForm-title">
        <FormattedMessage id="cheerz_CartMondialRelayForm_title" />
      </div>
      <div className="CartMondialRelayForm-input">
        <CartAutoCompleteStreetInput
          onChange={(value) => setSearchedAddress(value)}
          onSelect={handleSelectStreet}
          value={searchedAddress}
        />
      </div>
      <div className="CartMondialRelayForm-button">
        <Button onClick={() => onSubmit(submittedAddress)} type="primary" size="normal">
          <FormattedMessage id="cheerz_CartMondialRelayForm_search" />
        </Button>
      </div>
    </div>
  );
};

const CartMondialRelayFormContainer: FunctionComponent<ContainerProps> = ({ onSubmit }) => {
  const { configuration } = useCartContext();
  const { dispatchNotification } = useNotificationsContext();

  const handleSubmit = (place: AutoCompletePlace | undefined) => {
    if (place) {
      const params = {
        alpha2Code: place.country,
        position: { lat: place.position.lat, lng: place.position.lng },
      };

      configuration.apiProviders.konnektor
        .getMondialRelayLocations(params)
        .then((locations) => onSubmit(convertFromApiToMondialRelayLocationContent(locations)))
        .catch((error: ApiErrorResponse) => {
          const errorDescription: string[] | undefined =
            error.response?.data?.error_description ?? undefined;
          if (errorDescription) {
            dispatchNotification({
              code: "CFE-002",
              message: errorDescription[0],
              type: "addNotificationByCode",
            });
          } else {
            dispatchNotification({
              code: "CFE-004",
              type: "addNotificationByCode",
            });
          }
        });
    }
  };

  return <CartMondialRelayForm onSubmit={handleSubmit} />;
};

export default CartMondialRelayFormContainer;
